import { AtlassianProductHostingType, HostingTypesWithCloudComplianceBoundaries } from '@atlassian/mpac-types';
export function convertToAtlassianHostingType(hostingOption) {
  switch (hostingOption) {
    case HostingTypesWithCloudComplianceBoundaries.Cloud:
      return AtlassianProductHostingType.Cloud;
    case HostingTypesWithCloudComplianceBoundaries.DataCenter:
      return AtlassianProductHostingType.DataCenter;
    case HostingTypesWithCloudComplianceBoundaries.Server:
      return AtlassianProductHostingType.Server;
    default:
      return AtlassianProductHostingType.Cloud;
  }
}